import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import GoogleReviews from "@/components/GoogleReviews";

const ALLIANCE_URL = "https://allianceleasing.com.au/";

export default function NovatedLeaseCalculator() {
    return (
        <section id="leasing" className="border-b border-border bg-white" data-testid="lease-section">
            <div className="mx-auto grid max-w-7xl items-start gap-12 px-5 py-20 md:px-8 md:py-28 lg:grid-cols-2">
                <motion.div
                    initial={{ opacity: 0, x: -36 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7 }}
                >
                    <h2 className="font-display text-3xl font-bold leading-tight text-primary sm:text-4xl" data-testid="lease-heading">
                        Same car. Less tax. No leasing fees.
                    </h2>
                    <p className="mt-4 text-lg text-foreground/80" data-testid="lease-subheading">
                        Pick your car and see what you could save in under two minutes.
                    </p>

                    <div className="mt-8 overflow-hidden rounded-2xl border border-border shadow-lg">
                        <img
                            src="/novated-lease-car.jpg"
                            alt="Family enjoying a lakeside picnic beside their red Toyota RAV4"
                            className="block h-full w-full object-cover"
                            loading="lazy"
                            data-testid="lease-car-image"
                        />
                    </div>

                    <div className="mt-8 flex flex-wrap items-center gap-8">
                        <img
                            src="/alliance-leasing-logo.jpg"
                            alt="Alliance Leasing"
                            className="h-28 w-auto"
                            loading="lazy"
                            data-testid="lease-alliance-logo"
                        />
                        <a
                            href={ALLIANCE_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="lease-alliance-link"
                            className="group inline-flex items-center gap-3 rounded-xl bg-[#0B6E3B] px-8 py-5 text-xl font-bold text-white shadow-md transition-colors duration-200 hover:bg-[#095A30] sm:text-2xl"
                        >
                            See your savings now
                            <ArrowUpRight size={22} className="transition-transform duration-300 group-hover:rotate-45" />
                        </a>
                    </div>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, x: 36 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7, delay: 0.12 }}
                >
                    <GoogleReviews />
                </motion.div>
            </div>
        </section>
    );
}
